import {
  Apple,
  Award,
  Bird,
  Bot,
  Cat,
  ChessKing,
  Crown,
  Dog,
  ChevronRight,
  Download,
  Eye,
  Fish,
  Gamepad,
  Globe,
  GraduationCap,
  Heart,
  Lightbulb,
  MessageSquare,
  Monitor,
  Moon,
  Palette,
  PartyPopper,
  Play,
  Rabbit,
  Smile,
  Smartphone,
  Sparkles,
  Star,
  Sun,
  Tablet,
  Trophy,
  Turtle,
  Users,
  Volume2,
  Wifi,
  type LucideIcon,
} from 'lucide-react';

export const S4K_ICONS = {
  ChevronRight,
  Sun,
  Moon,
  Download,
  Play,
  Sparkles,
  Wifi,
  GraduationCap,
  Trophy,
  Users,
  Globe,
  Monitor,
  Smartphone,
  Tablet,
  Apple,
  Bot,
  Cat,
  Dog,
  Bird,
  Fish,
  Rabbit,
  Turtle,
  PartyPopper,
  MessageSquare,
  Lightbulb,
  Volume2,
  Gamepad,
  ChessKing,
  Crown,
  Award,
  Star,
  Heart,
  Eye,
  Smile,
  Palette,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof S4K_ICONS;

export type IconSize = 'sm' | 'md' | 'lg';

const SIZE_CLASS: Record<IconSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

export interface IconProps {
  readonly name: IconName;
  readonly size?: IconSize;
  readonly className?: string;
  /** Accessible label for screen readers. Rendered as aria-label so the icon isn't read out by default. */
  readonly label?: string;
}

/**
 * Typed lucide-react wrapper with the S4K sizing convention:
 * sm = inline (16px), md = nav (20px), lg = hero tile (24px).
 * Centralizes the registry — adding an icon is a one-line change.
 */
export function Icon({ name, size = 'md', className = '', label }: IconProps) {
  const Cmp = S4K_ICONS[name];
  return (
    <Cmp
      className={`${SIZE_CLASS[size]} ${className}`}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    />
  );
}
